const getMediaDownloadPath = require("./getMediaDownloadPath");

module.exports = function transformResourcesData(entity) {
	const { attributes, id, type, relationships } = entity;
	let data = {
		id,
		type,
		title: attributes.title,
		media: [],
	};
	if (
		relationships.field_media &&
		relationships.field_media.data &&
		Array.isArray(relationships.field_media.data)
	) {
		data.media = relationships.field_media.data.map((media_rel) => {
			let url = getMediaDownloadPath(media_rel);
			let m = {
				id: media_rel.id,
				title: media_rel.attributes.name,
				url: url.uri,
				external: url.external,
				format: url.external ? "url" : "document",
			};
			return m;
		});
	}
	return data;
};
